export default __webpack_public_path__ + "static/screen-classic-mac-laptop@2x-4f8953dec2f351982d29eb135f640043.png";